<template>
  <form-group :validator="v" :label="$t('category')">
     <select @change="selectCtype($event)" name="selectCtype" v-model="categoryName">
            <option v-for="data in categoryTypeName">{{data}}</option>
          </select>
    <div class="add-category">
    <span @click="addCategory()" class="addcategory_btn">+ {{$t('AddNewCategory')}}</span>
    </div>   
    <div class="category_popup" v-if="isAddCategory">
      <div class="add_content">
        <h3>{{$t('AddNewCategory')}}</h3>
      <input type="text" id="createCategoryId" :placeholder="$t('Createcategory')"  @input="handleChange($event)">
      <div class="button_block">
      <span class="create_btn" @click="createCategory()" :disabled="addCategoryButton">{{$t('CREATE')}}</span>
          <span class="create_btn cancel_btn" @click="isAddCategory = !isAddCategory">{{$t('CANCEL')}}</span>
      </div>
      </div>
    </div>
  </form-group>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(["category"]),
    categoryName: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data(){
    return{
      isAddCategory: false,
      add_category:'',
      categoryTypeName: {},
      addCategoryButton: false
    }
  },
  methods: {
    selectCtype(event) {
      this.categoryName = event.target.value;
    },
    addCategory(event){
      this.isAddCategory = !this.isAddCategory;
    },
    handleChange(event){
      this.add_category = event.target.value
      this.addCategoryButton = false
    },
    createCategory(){
     this.addCategoryButton = true
      //  document.getElementById('createCategoryId').value='';
      if(this.add_category == ""){
         this.addCategoryButton = false
        return;
      }
      if(this.category.includes(this.add_category)){
         this.addCategoryButton = false
        document.getElementById('createCategoryId').value='';
        this.$toast.bottom('This Category Already Exists');
        return;
      }
      var obj = {
        categoryName: this.add_category
      };
      this.$store.dispatch({ type: "postCategory", payload: obj }).then(
        data => {
          if(data.status == "Success"){
            this.isAddCategory = !this.isAddCategory;
            this.categoryTypeName = data;
            this.addCategoryButton = true
            this.category.push(data.category_name)
            this.$store.dispatch({ type: "getCategory" })
            this.categoryTypeName = this.category
            document.getElementById('createCategoryId').value='';
            console.log('---this.categoryTypeName---add--',this.categoryTypeName)
          }
        },
        response => {}
      );
    }
  },
  async mounted(){
    await this.$store.dispatch({ type: "getCategory" })
    this.categoryTypeName = this.category;
  }
};
</script>
